/*
 * @Author: mina.min
 * @Date: 2025-01-20 10:00:00
 * @LastEditors: mina.min
 * @LastEditTime: 2025-08-06 19:55:30
 * @FilePath: /OTAManagementSystem/src/pages/CampaignManagement/index.tsx
 * @Description: Campaign管理主组件
 */
import React from 'react'
import CampaignList from './CampaignList'
import './index.scss'

const CampaignManagement: React.FC = () => {
  return (
    <div className='campaign-management-wrapper'>
      <CampaignList />
    </div>
  )
}

export default CampaignManagement
